import React, { ImgHTMLAttributes, useEffect, useRef } from "react";

import { buildCdnImageUrl } from "../../helpers/cdnImageUrl";

// @ts-ignore
interface ImageProps extends ImgHTMLAttributes<HTMLImageElement> {
  src: string;
  dataSrc?: string | null;
  sizes?: string;
  loading?: "lazy" | "eager" | "progressive";
  alt: string;
  version?: number;
}

const Image: React.FC<ImageProps> = ({
  src,
  dataSrc,
  sizes,
  version,
  alt,
  loading,
  ...rest
}) => {
  const contentRef = useRef<HTMLImageElement>(null);
  const [imageSrc, setImageSrc] = React.useState<string>(src);

  const translateUrl = (dataSrc: string | null): string =>
    buildCdnImageUrl(dataSrc ?? src, sizes, version);

  useEffect(() => {
    if (contentRef.current) {
      contentRef.current.style.filter = "blur(10px)";
      contentRef.current.classList.add("image-loading");
    }

    setImageSrc(translateUrl(src));
  }, [dataSrc, sizes, src, version]);

  useEffect(() => {
    const translatedSrc = translateUrl(src);
    setImageSrc(translatedSrc);

    if (loading === "progressive") {
      if (contentRef.current) {
        contentRef.current.classList.add("image-loading");
      }
      const tmpImg = document.createElement("img") as HTMLImageElement;
      tmpImg.src = translateUrl(dataSrc ?? null);
      tmpImg.onload = () => {
        if (contentRef.current) {
          contentRef.current.style.filter = "none";
          contentRef.current.classList.add("image-loaded");
          contentRef.current.classList.remove("image-loading");
          contentRef.current.src = tmpImg.src;
        }
      };
    } else {
      if (contentRef.current) {
        contentRef.current.style.filter = "none";
        contentRef.current.classList.add("image-loaded");
        contentRef.current.classList.remove("image-loading");
      }
    }
  }, [dataSrc, sizes, src, loading, version]);

  return (
    <img
      ref={contentRef}
      src={imageSrc}
      alt={alt}
      style={{ filter: "blur(10px)", transition: "filter 0.3s ease-out" }}
      className="rounded-lg shadow-md max-w-full h-auto object-cover"
      {...rest}
    />
  );
};

export default Image;
